import { IObjectTranslatable, RelationalActionTranslator, ExternalCommonTranslator } from ".";
import { IExternalProcessItemBean, ITypeDefinable, BeanTypes } from "../beans/items";
import { IItem, ExternalProcessItem } from "../../../../domain/document/items";

import {
  Point,
  Size,
  Rectangle,
} from "../../../../domain/drawing";

export class ExternalProcessItemTranslator implements IObjectTranslatable {
  toItem(item: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const bean = item as IExternalProcessItemBean;
    const result = new ExternalProcessItem();
    result.privateId = (bean as any).privateId; // フロントエンド独自パラメータ.
    result.uniqueKey = bean.uniqueKey;
    result.id = bean.id;
    result.sectionObjectUid = bean.sectionObjectUid;
    result.isEditable = true; // TODO:特に問題なければプロパティを削除する
    result.isAdditional = !!bean.isAdditional;
    result.isDeleted = !!bean.isDeleted;
    result.isVisible = !!bean.isVisible;
    result.typeDetail = bean.typeDetail;
    result.viewTitle = bean.viewTitle;
    result.printBehavior.shouldPrint = !!bean.printVisible;
    result.printBehavior.shouldPreview = !!bean.previewVisible;
    result.name = bean.name;
    result.actions = RelationalActionTranslator.toItems(bean.relationalItems);
    result.geometry.rectangle = new Rectangle(new Point(bean.x, bean.y), new Size(bean.width, bean.height));
    result.exePath = bean.exePath;
    result.csvPath = bean.csvPath;
    result.xmlValuePath = bean.xmlValuePath;
    result.csvBeforeValuePath = bean.csvBeforeValuePath;
    result.csvInputValuePath = bean.csvInputValuePath;
    result.updateKind = bean.updateType;
    result.splitter = bean.splitter;
    result.items = ExternalCommonTranslator.toSubItems(bean.items);
    result.previousCsvBinary = bean.previousCsvBinary;
    result.textFontSize = bean.textFontSize;
    return result;
  }

  toBean(item: IItem): IExternalProcessItemBean {
    const target = item as ExternalProcessItem;
    return {
      type: BeanTypes.ExternalProcess,
      uniqueKey: target.uniqueKey,
      id: target.id,
      sectionObjectUid: target.sectionObjectUid,
      name: target.name,
      isVisible: target.isVisible,
      printVisible: target.printBehavior.shouldPrint,
      previewVisible: target.printBehavior.shouldPreview,
      x: target.geometry.rectangle.x,
      y: target.geometry.rectangle.y,
      width: target.geometry.rectangle.width,
      height: target.geometry.rectangle.height,
      isAdditional: target.isAdditional,
      isDeleted: target.isDeleted,
      relationalItems: null,  // TODO:返却する必要ある？
      exePath: target.exePath,
      csvPath: target.csvPath,
      xmlValuePath: target.xmlValuePath,
      csvBeforeValuePath: target.csvBeforeValuePath,
      csvInputValuePath: target.csvInputValuePath,
      updateType: target.updateKind,
      splitter: target.splitter,
      items: null,  // TODO:返却する必要ある？
      previousCsvBinary: target.previousCsvBinary,
      typeDetail: target.typeDetail,
      viewTitle: target.viewTitle,
      textFontSize: target.textFontSize,
    };
  }
}
